
import { useEffect, useState, useRef } from 'react';
// Assuming these are imported from your project, or you'd use plain HTML elements
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import { IoSearchOutline } from 'react-icons/io5';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { useAllinvestorsQuery } from '../../../store/services/investorService';
import Super_admin_web_protal from '../../../layout/Super_admin_web_portal';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { AiFillEdit } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';
import Swal from 'sweetalert2';
import axios from 'axios';
import ViewSlip from '../../manager/CompanyExpense/ViewSlip';
import { Base_url } from '../../../utils/Base_url';
import { InvestorsTableSkeleton } from '../../../components/Skeleton';

const PAGE_LIMIT = 8;


// Move this OUTSIDE and BEFORE the main Investors component
const EditModal = ({
    isEditModalOpen,
    closeEditModal,
    editingInvestor,
    editFormData,
    handleEditFormChange,
    handleEditSubmit,
    isUpdating,
    selectedImage,
    imagePreview,
    handleImageClick,
    fileInputRef,
    handleImageChange
}) => {
    if (!isEditModalOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-gray-800">Edit Investor</h2>
                    <button onClick={closeEditModal} className="text-gray-500 hover:text-gray-700">
                        <IoClose size={24} />
                    </button>
                </div>

                <form onSubmit={handleEditSubmit} className="space-y-4">
                    {/* CNIC Image Display Section */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">CNIC Image</label>
                        <div
                            className="border border-gray-300 rounded-md p-3 bg-gray-50 cursor-pointer"
                            onClick={handleImageClick}
                        >
                            {imagePreview ? (
                                <img
                                    src={imagePreview || '/placeholder.svg'}
                                    alt="New CNIC Preview"
                                    className="max-w-full h-auto max-h-48 mx-auto rounded border"
                                />
                            ) : (
                                <img
                                    src={editingInvestor?.images || '/placeholder.svg'}
                                    alt="CNIC Document"
                                    className="max-w-full h-auto max-h-48 mx-auto rounded border"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        // e.target.nextSibling.style.display = 'block'; // Removed potentially problematic line
                                    }}
                                />
                            )}
                            <div className="text-center text-gray-500 text-sm mt-2" style={{ display: 'none' }}>
                                Image not available
                            </div>
                            <p className="text-xs text-gray-600 mt-1 text-center">
                                {selectedImage
                                    ? selectedImage.name
                                    : editingInvestor?.images?.split('/').pop() || 'Click to upload new image'}
                            </p>
                        </div>
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleImageChange}
                            accept="image/*"
                            className="hidden"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                        <input
                            type="text"
                            name="fullName"
                            value={editFormData.fullName}
                            onChange={handleEditFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">CNIC</label>
                        <input
                            type="text"
                            name="cnic"
                            value={editFormData.cnic}
                            onChange={handleEditFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                        <input
                            type="text"
                            name="contactInfo"
                            value={editFormData.contactInfo}
                            onChange={handleEditFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                        <input
                            type="text"
                            name="password"
                            value={editFormData.password}
                            onChange={handleEditFormChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>

                    <div className="flex gap-3 pt-4">
                        <button
                            type="button"
                            onClick={closeEditModal}
                            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500"
                            disabled={isUpdating}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="flex-1 px-4 py-2 bg-blue-600 border border-gray-300 text-black rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
                            disabled={isUpdating}
                        >
                            {isUpdating ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};


// NEW: Hello World Modal Component (Updated to fetch and display bio data)
const HelloWorldModal = ({ isOpen, onClose, investorId }) => {
    // State to hold the form data for the bio fields
    const [bioFormData, setBioFormData] = useState({
        name: '',
        fatherName: '',
        permanentAddress: '',
        temporaryAddress: '',
        dateOfBirth: '',
        nationality: '',
        birthPlace: '',
        cast: '',
        maritalStatus: '',
        cnic: '',
        profession: '',
        phoneNumber: '',
        whatsappNumber: '',
        guardian: { // Nested object for guardian fields
            name: '',
            fatherName: '',
            relationship: '',
            permanentAddress: '',
            temporaryAddress: '',
            cnic: '',
            phoneNumber: '',
            whatsappNumber: '',
        },
    });
    const [isLoadingBio, setIsLoadingBio] = useState(false); // Initial state, will be set true in useEffect
    const [bioError, setBioError] = useState(null);
    const [isSavingBio, setIsSavingBio] = useState(false); // NEW: State for saving/updating bio data

    // Ref to track if data has been fetched for the current investorId
    const hasFetchedForCurrentId = useRef(null);

    useEffect(() => {
        // Reset state when modal is closed
        if (!isOpen) {
            setBioFormData({ // Reset to initial empty state
                name: '', fatherName: '', permanentAddress: '', temporaryAddress: '',
                dateOfBirth: '', nationality: '', birthPlace: '', cast: '',
                maritalStatus: '', cnic: '', profession: '', phoneNumber: '',
                whatsappNumber: '',
                guardian: {
                    name: '', fatherName: '', relationship: '', permanentAddress: '',
                    temporaryAddress: '', cnic: '', phoneNumber: '', whatsappNumber: '',
                },
            });
            setIsLoadingBio(false); // Ensure loading is false
            setBioError(null); // Clear errors
            setIsSavingBio(false); // Ensure saving state is reset
            hasFetchedForCurrentId.current = null; // Reset the fetched ID tracker
            return; // Exit if modal is closed
        }

        // If modal is open AND an investorId is provided AND
        // data for this specific investorId hasn't been fetched yet, then fetch.
        if (investorId && hasFetchedForCurrentId.current !== investorId) {
            setIsLoadingBio(true); // Indicate loading immediately
            setBioError(null); // Clear previous errors
            hasFetchedForCurrentId.current = investorId; // Mark this ID as being fetched

            const fetchBioData = async () => {
                try {
                    const requestOptions = {
                        method: "GET",
                        redirect: "follow"
                    };

                    const response = await fetch(`${Base_url}/v1/worker/bio-data-without-plan/${investorId}`, requestOptions);
                    const result = await response.json(); // Parse as JSON

                    if (result.success && result.bioData) {
                        const fetchedBio = result.bioData;

                        // Format dateOfBirth to 'YYYY-MM-DD' for input type="date"
                        if (fetchedBio.dateOfBirth) {
                            fetchedBio.dateOfBirth = new Date(fetchedBio.dateOfBirth).toISOString().split('T')[0];
                        }

                        setBioFormData({
                            name: fetchedBio.name || '',
                            fatherName: fetchedBio.fatherName || '',
                            permanentAddress: fetchedBio.permanentAddress || '',
                            temporaryAddress: fetchedBio.temporaryAddress || '',
                            dateOfBirth: fetchedBio.dateOfBirth || '',
                            nationality: fetchedBio.nationality || '',
                            birthPlace: fetchedBio.birthPlace || '',
                            cast: fetchedBio.cast || '',
                            maritalStatus: fetchedBio.maritalStatus || '',
                            cnic: fetchedBio.cnic || '',
                            profession: fetchedBio.profession || '',
                            phoneNumber: fetchedBio.phoneNumber || '',
                            whatsappNumber: fetchedBio.whatsappNumber || '',
                            guardian: {
                                name: fetchedBio.guardian?.name || '',
                                fatherName: fetchedBio.guardian?.fatherName || '',
                                relationship: fetchedBio.guardian?.relationship || '',
                                permanentAddress: fetchedBio.guardian?.permanentAddress || '',
                                temporaryAddress: fetchedBio.guardian?.temporaryAddress || '',
                                cnic: fetchedBio.guardian?.cnic || '',
                                phoneNumber: fetchedBio.guardian?.phoneNumber || '',
                                whatsappNumber: fetchedBio.guardian?.whatsappNumber || '',
                            },
                        });
                    } else {
                        setBioError(result.message || "Investor Bio not available.");
                        Swal.fire({
                            title: 'Error!',
                            text: result.message || 'Investor Bio not available.',
                            icon: 'error',
                            confirmButtonColor: '#d33'
                        });
                        onClose(); // Close modal if data is not available
                    }
                } catch (error) {
                    console.error("Error fetching bio data:", error);
                    setBioError("Failed to fetch bio data. Please try again.");
                    Swal.fire({
                        title: 'Error!',
                        text: 'Failed to fetch investor bio data. Please try again.',
                        icon: 'error',
                        confirmButtonColor: '#d33'
                    });
                    onClose(); // Close modal on network error
                } finally {
                    setIsLoadingBio(false); // Always set loading to false when done
                }
            };
            fetchBioData();
        }
    }, [isOpen, investorId, onClose]); // Depend on isOpen, investorId, and onClose


    // Render nothing if the modal is not open
    if (!isOpen) return null;

    // Display loading state if currently loading OR if investorId is provided but data hasn't been fetched yet
    // This is the core fix for the "blink" - it ensures the loading state is shown
    // from the very first render when the modal is opened for a new investorId.
    if (isLoadingBio || (investorId && hasFetchedForCurrentId.current !== investorId)) {
        return (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 text-center w-full max-w-sm mx-4">
                    <p className="text-gray-800">Loading Bio Data...</p>
                </div>
            </div>
        );
    }


    // Handle change for top-level bio fields
    const handleBioFormChange = (e) => {
        const { name, value } = e.target;
        setBioFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle change for nested guardian fields
    const handleGuardianChange = (e) => {
        const { name, value } = e.target;
        setBioFormData((prev) => ({
            ...prev,
            guardian: {
                ...prev.guardian,
                [name]: value,
            },
        }));
    };

    // UPDATED: Save functionality
    const handleSaveBio = async (e) => {
        e.preventDefault();
        setIsSavingBio(true); // Start saving state

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            // Prepare the data to be sent. Ensure all fields are included.
            const raw = JSON.stringify(bioFormData);

            const requestOptions = {
                method: "PATCH", // As specified by you
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            // Use the investorId from props in the URL
            const response = await fetch(`${Base_url}/v1/worker/bio-investor/${investorId}`, requestOptions);
            const result = await response.json(); // Assume API always returns JSON

            if (result.success) { // Check if the API call was successful
                Swal.fire({
                    title: 'Success!',
                    text: result.message || 'Bio data updated successfully.',
                    icon: 'success',
                    confirmButtonColor: '#00afef'
                });
                onClose(); // Close the modal on success
            } else {
                // If API indicates failure, show error message from API or a default
                throw new Error(result.message || 'Failed to update bio data.');
            }
        } catch (error) {
            console.error("Error updating bio data:", error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'Failed to update bio data. Please try again.',
                icon: 'error',
                confirmButtonColor: '#d33'
            });
        } finally {
            setIsSavingBio(false); // Stop saving state regardless of outcome
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-gray-800">Edit Bio Data</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <IoClose size={24} />
                    </button>
                </div>

                <form onSubmit={handleSaveBio} className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-700 mt-4 mb-2">Personal Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={bioFormData.name}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Father's Name</label>
                            <input
                                type="text"
                                name="fatherName"
                                value={bioFormData.fatherName}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Permanent Address</label>
                            <input
                                type="text"
                                name="permanentAddress"
                                value={bioFormData.permanentAddress}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Temporary Address</label>
                            <input
                                type="text"
                                name="temporaryAddress"
                                value={bioFormData.temporaryAddress}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
                            <input
                                type="date"
                                name="dateOfBirth"
                                value={bioFormData.dateOfBirth}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Nationality</label>
                            <input
                                type="text"
                                name="nationality"
                                value={bioFormData.nationality}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Birth Place</label>
                            <input
                                type="text"
                                name="birthPlace"
                                value={bioFormData.birthPlace}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Cast</label>
                            <input
                                type="text"
                                name="cast"
                                value={bioFormData.cast}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Marital Status</label>
                            <select
                                name="maritalStatus"
                                value={bioFormData.maritalStatus}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <option value="">Select status</option>
                                <option value="Single">Single</option>
                                <option value="Married">Married</option>
                                <option value="Divorced">Divorced</option>
                                <option value="Widowed">Widowed</option>
                            </select>
                        </div>




                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">CNIC</label>
                            <input
                                type="text"
                                name="cnic"
                                value={bioFormData.cnic}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Profession</label>
                            <input
                                type="text"
                                name="profession"
                                value={bioFormData.profession}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={bioFormData.phoneNumber}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp Number</label>
                            <input
                                type="text"
                                name="whatsappNumber"
                                value={bioFormData.whatsappNumber}
                                onChange={handleBioFormChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                    </div>

                    <h3 className="text-lg font-semibold text-gray-700 mt-6 mb-2">Guardian Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian Name</label>
                            <input
                                type="text"
                                name="name"
                                value={bioFormData.guardian.name}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian Father's Name</label>
                            <input
                                type="text"
                                name="fatherName"
                                value={bioFormData.guardian.fatherName}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Relationship</label>
                            <input
                                type="text"
                                name="relationship"
                                value={bioFormData.guardian.relationship}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian Permanent Address</label>
                            <input
                                type="text"
                                name="permanentAddress"
                                value={bioFormData.guardian.permanentAddress}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian Temporary Address</label>
                            <input
                                type="text"
                                name="temporaryAddress"
                                value={bioFormData.guardian.temporaryAddress}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian CNIC</label>
                            <input
                                type="text"
                                name="cnic"
                                value={bioFormData.guardian.cnic}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian Phone Number</label>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={bioFormData.guardian.phoneNumber}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Guardian WhatsApp Number</label>
                            <input
                                type="text"
                                name="whatsappNumber"
                                value={bioFormData.guardian.whatsappNumber}
                                onChange={handleGuardianChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                    </div>

                    <div className="flex justify-end gap-3 pt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500"
                            disabled={isSavingBio} // Disable button while saving
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500"
                            disabled={isSavingBio} // Disable button while saving
                        >
                            {isSavingBio ? 'Saving...' : 'Save Bio'} {/* Change text while saving */}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};


const Investors = () => {
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [getData, setGetData] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState('active');

    // State for the "Hello World" modal and the investor ID for bio data
    const [isBioModalOpen, setIsBioModalOpen] = useState(false);
    const [currentBioInvestorId, setCurrentBioInvestorId] = useState(null); // New state to hold investor ID for bio modal


    // Edit modal states (existing)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editingInvestor, setEditingInvestor] = useState(null);
    const [editFormData, setEditFormData] = useState({
        fullName: '',
        cnic: '',
        contactInfo: '',
        password: ''
    });
    const [isUpdating, setIsUpdating] = useState(false);

    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [isUploadingImage, setIsUploadingImage] = useState(false);

    const fileInputRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchTerm.trim());
            setCurrentPage(1);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        setCurrentPage(1);
    }, [statusFilter]);

    const { data, isLoading, isFetching, refetch } = useAllinvestorsQuery(
        {
            page: currentPage,
            limit: PAGE_LIMIT,
            search: debouncedSearch,
            status: statusFilter
        },
        { placeholderData: (previousData) => previousData }
    );

    const currentPageData = Array.isArray(data?.investors) ? data.investors : [];
    const totalItems = data?.total ?? 0;
    const totalPages = Math.max(1, data?.totalPages ?? 1);
    const showSkeleton = isLoading || (isFetching && currentPageData.length === 0);

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > totalPages || isFetching) return;
        setCurrentPage(newPage);
    };

    const removeFunction = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#00afef',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const params = {
                    ids: [id]
                };
                axios
                    .post(`${Base_url}/v1/admin/delete-investors`, params)
                    .then((res) => {
                        console.log(res);
                        Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
                        refetch();
                    })
                    .catch((error) => {
                        console.log(error);
                        Swal.fire('Error', 'Failed to delete investor.', 'error');
                    });
            }
        });
    };

    const editFunction = (investor) => {
        setEditingInvestor(investor);
        setEditFormData({
            fullName: investor.fullName || '',
            cnic: investor.cnic || '',
            contactInfo: investor.contactInfo || '',
            password: investor.password || ''
        });
        setImagePreview(investor.images || null);
        setSelectedImage(null);
        setIsEditModalOpen(true);
    };

    // UPDATED FUNCTION: to open the new "Hello World" modal and pass investor ID
    const bioFunction = (investor) => {
        console.log('bioFunction called for investor:', investor);
        setCurrentBioInvestorId(investor._id); // Set the ID for the bio modal
        setIsBioModalOpen(true); // Open the Hello World modal
    };

    // NEW FUNCTION: to close the new "Hello World" modal
    const closeBioModal = () => {
        setIsBioModalOpen(false);
        setCurrentBioInvestorId(null); // Clear the ID when closing
    };


    const handleEditFormChange = (e) => {
        const { name, value } = e.target;
        setEditFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const uploadImageToCloudinary = async (file) => {
        const formdata = new FormData();
        formdata.append('images', file);

        const requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        try {
            const response = await fetch(
                'https://file-upload-ashen.vercel.app/api/upload',
                requestOptions
            );
            const result = await response.text();
            const data = JSON.parse(result);

            console.log('Image uploaded successfully:', data.data[0]);

            // Return the uploaded image URL
            return data.data[0];
        } catch (error) {
            console.error('Error uploading image:', error);
            throw error;
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setIsUpdating(true);

        try {
            let imageUrl = editingInvestor.images; // Keep existing image by default

            // Upload new image if selected
            if (selectedImage) {
                setIsUploadingImage(true);
                console.log('Uploading new image...');
                imageUrl = await uploadImageToCloudinary(selectedImage);
                console.log('New image URL:', imageUrl);
            }

            const myHeaders = new Headers();
            myHeaders.append('Content-Type', 'application/json');

            const raw = JSON.stringify({
                cnic: editFormData.cnic,
                fullName: editFormData.fullName,
                contactInfo: editFormData.contactInfo,
                password: editFormData.password,
                images: imageUrl,
                _id: editingInvestor._id // Ensure the _id is sent for update
            });

            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            const response = await fetch(
                'https://welcome-habibi-backend.vercel.app/v1/worker/change-password',
                requestOptions
            );
            const result = await response.json();

            if (result.success) {
                Swal.fire({
                    title: 'Success!',
                    text: result.message || 'Investor updated successfully.',
                    icon: 'success',
                    confirmButtonColor: '#00afef'
                });
                setIsEditModalOpen(false);
                setEditingInvestor(null);
                setSelectedImage(null);
                setImagePreview(null);
                refetch();
            } else {
                throw new Error(result.message || 'Failed to update investor');
            }
        } catch (error) {
            console.error('Error updating investor:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'Failed to update investor. Please try again.',
                icon: 'error',
                confirmButtonColor: '#d33'
            });
        } finally {
            setIsUpdating(false);
            setIsUploadingImage(false);
        }
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setEditingInvestor(null);
        setEditFormData({
            fullName: '',
            cnic: '',
            contactInfo: '',
            password: ''
        });
        setSelectedImage(null);
        setImagePreview(null);
    };

    return (
        <Super_admin_web_protal
            language={
                <>
                    <p className=" sm:block hidden">English | Urdu</p>
                </>
            }
            ToggleBtn={
                <div className=" flex gap-4 items-center">
                    <HiOutlineArrowLeft />
                    <h2 className="">Investors</h2>
                </div>
            }
            title_props={
                <>
                    <div className=" w-96 relative">
                        <Input
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder={''}
                            className={' border bg-white w-full rounded-full'}
                        />

                        <Button
                            Icon={<IoSearchOutline className=" text-white text-xl" />}
                            label={'search'}
                            className={
                                ' absolute top-0 right-0 bg-secondary  text-white uppercase font-normal rounded-full'
                            }
                        />
                    </div>
                </>
            }
        >
            <div className="  w-full  mb-4  md:hidden block relative">
                <Input placeholder={''} className={' border bg-white w-full rounded-full'} />

                <Button
                    Icon={<IoSearchOutline className=" text-white text-xl" />}
                    label={'search'}
                    className={
                        ' absolute top-0 right-0 bg-secondary text-white uppercase font-normal rounded-full'
                    }
                />
            </div>
            <div className=" sm:flex block    justify-between items-center">
                <div>
                    <h2 className="sm:block hidden">Investors</h2>
                    <p className="text-sm text-gray-500 mt-1">
                        {isFetching && !showSkeleton
                            ? 'Updating...'
                            : `${totalItems} investor${totalItems !== 1 ? 's' : ''} found`}
                    </p>
                </div>

                <div className=" flex gap-3 items-center"></div>
            </div>

            <div className="flex flex-wrap gap-2 mt-4 mb-2">
                {[
                    { key: 'all', label: 'All' },
                    { key: 'active', label: 'Active' },
                    { key: 'inactive', label: 'Inactive' }
                ].map((item) => (
                    <button
                        key={item.key}
                        type="button"
                        onClick={() => setStatusFilter(item.key)}
                        className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-colors ${
                            statusFilter === item.key
                                ? 'bg-secondary text-white border-secondary'
                                : 'bg-white text-gray-600 border-gray-300 hover:border-secondary hover:text-secondary'
                        }`}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            <section className="mb-20 mt-7 text-gray-800">
                <div className="block rounded-lg ">
                    <div className="flex overflow-x-auto flex-col">
                        <div className=" sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full sm:px-6 lg:px-8">
                                <div className="overflow-hidden">
                                    <table className="min-w-full mb-0">
                                        <thead className=" ">
                                            <tr className=" rounded-lg whitespace-nowrap ">
                                                <th scope="col" className=" text-sm  text-darkGray  font-medium px-6">
                                                    Name
                                                </th>
                                                <th scope="col" className=" text-sm text-darkGray     font-medium px-6 ">
                                                    CNIC No
                                                </th>

                                                <th scope="col" className="text-sm  text-darkGray   font-medium px-6 ">
                                                    Phone Number
                                                </th>

                                                <th scope="col" className="text-sm  text-darkGray     font-medium px-6 ">
                                                    CNIC Copy
                                                </th>
                                                <th scope="col" className="text-sm     text-darkGray   font-medium px-6 ">
                                                    Password
                                                </th>
                                                <th scope="col" className="text-sm      text-darkGray   font-medium px-6 ">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="">
                                            {showSkeleton ? (
                                                <InvestorsTableSkeleton rows={PAGE_LIMIT} showActions />
                                            ) : currentPageData.length > 0 ? (
                                            currentPageData.map((item) => {
                                                return (
                                                    <tr
                                                        key={item._id}
                                                        className="bg-white border-t-8 border-b-8    border-[#F6F6F6]  rounded-md "
                                                    >
                                                        <th
                                                            scope="row"
                                                            className="text-sm font-normal px-6 py-4  whitespace-nowrap "
                                                        >
                                                            <Link
                                                                onClick={() => localStorage.setItem('iName', item?.fullName)}
                                                                to={`/super_admin/investorsDetails/${item?.cnic}/${item?._id}`}
                                                                className="mb-0.5 font-medium  text-secondary"
                                                            >
                                                                {item?.fullName}
                                                            </Link>
                                                        </th>
                                                        <td className="align-middle text-sm font-normal px-6 py-4 whitespace-nowrap  text-center">
                                                            <span className=" text-base text-black  py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline   bg-green-200  rounded-full">
                                                                {item?.cnic}
                                                            </span>
                                                        </td>

                                                        <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                                            <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                                                {item?.contactInfo}
                                                            </span>
                                                        </td>
                                                        <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                                                            <span
                                                                onClick={() => {
                                                                    setIsModalOpen2(true);
                                                                    setGetData(item);
                                                                }}
                                                                className=" text-base text-secondary  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full cursor-pointer"
                                                            >
                                                                {item?.images?.slice(-6)}
                                                            </span>
                                                        </td>

                                                        <td className="align-middle text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                                            <span className=" text-base text-black  py-1 px-2.5 leading-none  whitespace-nowrap    bg-green-200  rounded-full">
                                                                {item?.password}
                                                            </span>
                                                        </td>
                                                        <td className="align-middle text-sm font-normal text-center whitespace-nowrap px-6">
                                                            <div className="inline-flex items-center space-x-3">
                                                                <span
                                                                    onClick={() => removeFunction(item?._id)}
                                                                    className="text-base cursor-pointer text-[#d33] hover:text-red-700 p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
                                                                >
                                                                    <RiDeleteBin5Line size={20} />
                                                                </span>
                                                                <span
                                                                    onClick={() => editFunction(item)}
                                                                    className="text-base cursor-pointer text-gray-800 hover:text-gray-900 p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
                                                                >
                                                                    <AiFillEdit size={20} />
                                                                </span>
                                                                <span
                                                                    onClick={() => bioFunction(item)}
                                                                    className="
                                                                        inline-flex items-center justify-center
                                                                        px-3 py-1.5
                                                                        text-sm font-medium
                                                                        rounded-md
                                                                        text-blue-700 bg-blue-50
                                                                        hover:bg-blue-100 hover:text-blue-800
                                                                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50
                                                                        transition-all duration-200 ease-in-out
                                                                        cursor-pointer
                                                                        shadow-sm hover:shadow-md
                                                                    "
                                                                >
                                                                    Edit Bio
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} className="px-6 py-12 text-center text-gray-500">
                                                        No investors found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {!showSkeleton && totalItems > 0 && (
                    <div className=" flex justify-end items-center  py-4 gap-6">
                        <button
                            className={`${currentPage === 1 || isFetching ? 'bg-gray-500  text-white' : 'bg-secondary text-white'
                                } flex justify-center items-center  w-10 h-10 rounded-md`}
                            disabled={currentPage === 1 || isFetching}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <FaAngleLeft size={20} />
                        </button>
                        <span className=" text-primary font-semibold">
                            {currentPage} of {totalPages}
                            <span className="text-gray-400 font-normal text-sm ml-2">
                                ({totalItems} total)
                            </span>
                        </span>
                        <button
                            className={`${currentPage >= totalPages || isFetching
                                ? 'bg-gray-500  text-white'
                                : 'bg-secondary text-white'
                                } flex justify-center items-center  w-10 h-10 rounded-md`}
                            disabled={currentPage >= totalPages || isFetching}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            <FaAngleRight size={20} />
                        </button>
                    </div>
                    )}
                </div>

                {/* Edit Modal (Existing one for investor data) */}
                <EditModal
                    isEditModalOpen={isEditModalOpen}
                    closeEditModal={closeEditModal}
                    editingInvestor={editingInvestor}
                    editFormData={editFormData}
                    handleEditFormChange={handleEditFormChange}
                    handleEditSubmit={handleEditSubmit}
                    isUpdating={isUpdating}
                    selectedImage={selectedImage}
                    imagePreview={imagePreview}
                    handleImageClick={handleImageClick}
                    fileInputRef={fileInputRef}
                    handleImageChange={handleImageChange}
                />

                {/* Existing ViewSlip Modal */}
                <ViewSlip isModalOpen={isModalOpen2} setIsModalOpen={setIsModalOpen2} images={getData} />

                {/* NEW: Hello World Modal (now with investorId prop) */}
                <HelloWorldModal isOpen={isBioModalOpen} onClose={closeBioModal} investorId={currentBioInvestorId} />
            </section>
        </Super_admin_web_protal>
    );
};

export default Investors;
